import PropTypes from 'prop-types';
import React, { useCallback, useRef } from 'react';
import linkStyles from '../../styles/link.module.css';
import css from './ShareTextPreview.module.css';

const ShareTextPreview = ({ className, text }) => {
  const classes = [css.root, className].filter(Boolean).join(' ');
  if (!text) return null;
  const lines = (text || '').split(/\r?\n/);
  const containerRef = useRef(null);

  const handleKeyDown = useCallback(event => {
    const isSelectAll = (event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'a';
    if (!isSelectAll) {
      return;
    }

    if (typeof window === 'undefined' || !containerRef.current) {
      return;
    }

    event.preventDefault();
    const selection = window.getSelection();
    if (!selection) {
      return;
    }

    const range = document.createRange();
    range.selectNodeContents(containerRef.current);
    selection.removeAllRanges();
    selection.addRange(range);
  }, []);
  return (
    <div
      className={classes}
      tabIndex={0}
      role="textbox"
      aria-readonly="true"
      data-testid="shareTextPreview"
      onKeyDown={handleKeyDown}
      ref={containerRef}
    >
      {lines.map((line, idx) => {
        const original = line || '';
        const hasNonWhitespace = original.trim().length > 0;

        // Find URL anywhere in the line
        const urlMatch = original.match(/https?:\/\/\S+/i);
        const hasUrl = !!urlMatch;

        if (hasUrl) {
          const url = urlMatch[0];
          const urlStartIndex = urlMatch.index;
          const prefix = original.slice(0, urlStartIndex);
          const suffix = original.slice(urlStartIndex + url.length);

          return (
            <div key={idx} className={css.line}>
              <span>
                {prefix}
                <a className={linkStyles.link} href={url} target="_blank" rel="noopener noreferrer">
                  {url}
                </a>
                {suffix}
              </span>
            </div>
          );
        }

        return (
          <div key={idx} className={css.line}>
            {hasNonWhitespace ? original : '\u00A0'}
          </div>
        );
      })}
    </div>
  );
};

ShareTextPreview.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
};

ShareTextPreview.defaultProps = {
  className: '',
};

export default ShareTextPreview;
